<template>
	<div class="base">
		<div class="base_top clearfloat">
			<div class="base_imgs">
				<div class="imgs_title">在线小工具</div>
				<span @click="xin.goUrl('/tool')">实验工具</span>
				<span class="nav_ge">|</span>
				<span @click="xin.goUrl('/dilutionCalculator')">稀释计算器</span>
				<span class="nav_ge">|</span>
				<span @click="xin.goUrl('/molalityCalculator')">摩尔浓度计算器</span>
			</div>
			<div class="base_rew">
				<div class="base_zi" >
					<span class="zi_title">产品订购</span>
					<span @click="xin.goUrl('/product')">产品中心</span>
					<span @click="xin.goUrl('/journalism/news')">产品最新动态</span>
					<span @click="xin.goUrl('/activity')">促销活动</span>
					<span @click="xin.goUrl('/aboutUs/flow')">订单流程</span>
				</div>
				<div class="base_zi" >
					<span class="zi_title">技术支持</span>
					<span @click="xin.goUrl('/explain')">说明书下载</span>
					<span @click="xin.goUrl('/studyData')">学习资料</span>
					<span @click="xin.goUrl('/video')"> 产品操作视频</span>
					<span @click="xin.goUrl('/aboutUs/contactUs')">联系我们</span>
				</div>
				<div class="base_zi" >
					<span class="zi_title">个人中心</span>
					<span @click="xin.goUrl('/shopping')">我的购物车</span>
					<span @click="xin.goUrl('/personalCenter/orderForm')">我的订单</span>
					<span @click="xin.goUrl('/personalCenter/personal')">个人信息</span>
					<span @click="xin.goUrl('/applyVip')">VIP申请</span>
				</div>
				<div class="base_zi" >
					<span class="zi_title">关于我们</span>
					<span @click="xin.goUrl('/aboutUs/about')">走进同仁</span>
					<span @click="xin.goUrl('/aboutUs/joinUs')">招聘信息</span>
					<span @click="xin.goUrl('/orderAgreement')">订购协议</span>
					<span @click="xin.goUrl('/userAgreement')">注册协议</span>
				</div>
			</div>
		</div>
		<div class="base_bgcolor">
			<div class="base_bottom clearfloat">
				<div class="base_logo">
					<img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/img/20201019/02d3e600d7cb071501623bfa22170a4f6f426bef.png"/>
				</div>
				<div class="base_wei">
					<div v-html="boy"></div>
					<div>
						<span @click="xin.goUrl('/userAgreement')">注册协议 </span>
						<span class="nav_ge">|</span>
						<span @click="xin.goUrl('/orderAgreement')">订购协议</span>
						<span class="nav_ge">|</span>
						<span @click="xin.goNew('https://beian.miit.gov.cn/')">沪ICP备17016160号-1</span>
					</div>
					<div></div>
				</div>
				<div class="base_code">
					<img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/qrcode_for_gh_1bf2f15c3a63_430.jpg"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {//index_bottom
				boy:{}
			}
		},
		created(){
			this.getbott();
		},
		methods:{
			async getbott(){
				let {data} = await this.api.PostuserCommon({name:'index_bottom'});
				this.boy = data;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.base{
		width: 100%;
		height: 500px;
		border-top: solid 1px #e6e6e6;
		margin-top: 100px;
		// border: 1px solid;
		.base_top{
			width: 1200px;
			height: 300px;
			margin: 0 auto;
			.base_imgs{
				color: #fff;
				float: left;
				margin-top: 50px;
				width: 410px;
				height: 170px;
				background:url('https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/c369e22ee102088d8a77d27ad82ea68.png');
				span{
					cursor: pointer;
				}
				.imgs_title{
					margin: 45px 0 0 60px;
					font-size: 24px;
					padding-bottom: 10px;
				}
				& :nth-child(2){
					margin: 45px 0 0 60px;
				}
			}
			.base_rew{
				// border: 1px solid;
				float: right;
				margin-top: 50px;
				.base_zi{
					float: left;
					display: grid;
					// justify-content: space-around;
					margin-left: 100px;
					// border: 1px solid;
					span{
						cursor: pointer;
						margin-bottom: 12px;
						font-size: 16px;
						color: #666666;
					}
					.zi_title{
						cursor: default;
						color: #333333;
						font-size: 20px;
						font-weight: 500;
						color: #333333;
					}
				}
			}
		}
		.base_bgcolor{
			// height: 200px;
			background: #005699;
			.base_bottom{
				// box-sizing: border-box;
				// height: 140px;
				width: 1200px;
				margin:0 auto;
				padding-top: 30px;
				.base_logo{
					float: left;
					height: 100%;
					line-height: 160px;
					img{
						width: 150px;
					}
				}
				.base_wei{
					// height: 140px;
					float: left;
					margin-left: 25px;
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					color: #fff;
					span{
						cursor: pointer;
					}
				}
				.base_code{
					height: 100%;
					float: right;
					line-height: 140px;
					img{
						width: 140px;
						height: 140px;
					}
				}
			}
		}
	}
</style>
